import { Components } from '../../material';

export const MuiPopover: Components['MuiPopover'] = {
  defaultProps: {
    slotProps: {
      paper: {
        elevation: 6,
      },
    },
  },
  styleOverrides: {},
};
